import Link from '@eliadmin/core/src/components/link';
import React from 'react';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { LuArrowRight } from 'react-icons/lu';

export type ProfileSidebarItemProps = {
  name: string;
  icon: React.ReactNode;
  variant?: any;
  href: string | (() => string);
  hardLink?: boolean;
  pathname: string;
};

export const ProfileSidebarItem = ({
  name,
  icon,
  variant,
  hardLink,
  href,
}: ProfileSidebarItemProps) => {
  const LinkComponent = hardLink ? 'a' : Link;
  const hrefString = typeof href === 'function' ? href() : href;

  return (
    <LinkComponent
      key={hrefString + name}
      href={hrefString ?? '#'}
      className={cn(
        'flex h-14 items-center justify-between gap-3 rounded-[4px] bg-[#F9FAFB] px-3 hover:bg-primary-foreground',
      )}
    >
      {icon && icon}
      <Heading
        tag="h6"
        title={name}
        className={{
          container: 'w-full flex-1',
          title: cn('text-left', variant == 'destructive' ? 'text-[#666666]' : 'text-black'),
        }}
      />
      {variant !== 'destructive' && <LuArrowRight size={20} className="text-primary" />}
    </LinkComponent>
  );
};
